<template>
    <section>
        {{$route.params}} <br>        
        {{$route.query}}
    </section>
</template>

<script>
/**
 * 단독 설문 다이나믹 링크 브릿지 컴포넌트(independant survey dynamic link bridge component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {dynamicMixin} from '@/mixins/dynamic.js'

export default {
    mixins: [dynamicMixin],
    async mounted() {
        this.$showLoading()

        // 브랜드 정보/언어 설정(set brand & language)
        await this.setBrandInfo()

        let loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.path)}`
        let distId = this.$route.params.distId

        // move Independent Survey Total View
        this.$router.push({
            name: 'IndependentSurveyTotalView',
            params: {
                distId: distId
            }
        })

        setTimeout(() => {
            this.$hideLoading()
        }, 1000)

        
    },
}
</script>